import { Plural, useLingui } from '@lingui/react/macro';

import type { CheckoutPromotionPreview } from 'src/api/endpoints/cloudConnect.types';

type AppliedPromotion = CheckoutPromotionPreview['appliedPromotion'];

// A 100% discount for a limited number of months is presented as free Connect, not a free trial.
export const freePromotionMonths = ({
  percentOff,
  duration,
  durationMonths,
}: AppliedPromotion) =>
  percentOff === 100 && duration === 'repeating' && durationMonths
    ? durationMonths
    : undefined;

export function FreeConnectTitle({ months }: Readonly<{ months: number }>) {
  const { t } = useLingui();

  if (months === 12) {
    return t`1-year free Connect`;
  }

  return (
    <Plural
      value={months}
      one="#-month free Connect"
      other="#-month free Connect"
    />
  );
}
